/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ProjectsActions, ProjectsActionTypes } from './types';

const { GET_USER_PROJECTS_WATCHER } = ProjectsActions;

export const fetchProjectsByUser = (): ProjectsActionTypes => ({
  type: GET_USER_PROJECTS_WATCHER,
});
